import { store } from 'lib';

export default key => store.getState().staticData[key] || null;
